export const ASCENDENTE = "ascendente";
export const DESCENDENTE = "descendente";
export const MAYOR = "mayor";
export const MENOR = "menor";
export const MEJOR = "mejor";
export const PEOR = "peor";
export const TOOGLE_CART = "TOOGLE_CART";
